import { Injectable } from '@angular/core';
import { Cartao } from '../classes/cartao';

@Injectable()
export class VoucherService {

  public voucherPrincipal: Cartao;
  public vouchersAdicionais: Array<Cartao>;

}



// WEBPACK FOOTER //
// ./src/app/resources/services/voucher.service.ts